<template>
  <div class="next" v-for="item in list" :key="item.id">
    <span v-if="!item.leaf">
      <van-icon  name="arrow" />
      {{ item.title }}
    </span>
    <span v-else>
       <van-checkbox shape="square" :name="item.id">{{ item.title }}</van-checkbox>
    </span>
    <list-item-next :list="item.empList" />
  </div>
</template>

<script>
export default {
  name: 'ListItemNext',
  props: {
    list: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.next {
  padding-left: 18px;
  margin-top: 10px;
}
</style>
